import React, { useEffect, useState } from 'react';

const Dashboard: React.FC = () => {
 


  return (
  
    <div className="content">


     
    </div>


  );
};

export default Dashboard